import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { validateTidalLicense } from "../../../base/index.js";
import { mergeSx } from "../../../utils/index.js";
function WorkWavePaymentsInverted(props) {
  const { width = "100%", sx, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      "data-testid": "workWavePaymentsInvertedLogo",
      sx: mergeSx(sx, { height: "auto", width }),
      titleAccess: "WorkWave Payments",
      viewBox: "0 0 287 80",
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M101.099 43.0769H96.5079V53.5286H91.0378V26.276H101.099C107.643 26.276 110.965 29.9878 110.965 34.6765C110.965 38.779 108.132 43.0769 101.099 43.0769ZM100.904 38.5837C104.029 38.5837 105.397 37.0208 105.397 34.6765C105.397 32.1368 104.029 30.6716 100.904 30.6716H96.6056V38.5837H100.904Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M123.272 31.5505C126.789 31.5505 129.133 33.2111 130.403 34.9693V31.8436H135.873V53.5286H130.403V50.4028C129.133 52.2588 126.691 53.9193 123.175 53.9193C117.704 53.9193 113.309 49.426 113.309 42.6861C113.309 35.9462 117.802 31.5505 123.272 31.5505ZM124.737 36.3369C121.807 36.3369 119.072 38.4859 119.072 42.5884C119.072 46.691 121.807 49.0353 124.737 49.0353C127.765 49.0353 130.501 46.7887 130.501 42.6861C130.501 38.5835 127.668 36.3369 124.737 36.3369Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M156.19 31.8436H162.051L149.646 60.3662H143.785L147.497 52.9425L138.803 31.8436H144.957L150.525 46.984L156.19 31.8436Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M195.263 41.514C195.263 38.0952 193.309 36.2392 190.476 36.2392C187.546 36.2392 185.592 37.9975 185.592 41.514V53.4309H180.122V41.514C180.122 38.0952 178.169 36.2392 175.336 36.2392C172.405 36.2392 170.452 37.9975 170.452 41.514V53.4309H164.982V31.746H170.452V34.3833C171.819 32.625 174.164 31.4529 176.801 31.4529C180.122 31.4529 182.955 32.9182 184.42 35.5555C185.788 33.1135 188.718 31.4529 191.844 31.4529C197.021 31.4529 200.733 34.774 200.733 40.7325V53.4309H195.263V41.514Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M215.385 53.8216C209.133 53.8216 204.542 49.426 204.542 42.6861C204.542 35.8485 209.035 31.5505 215.385 31.5505C221.636 31.5505 226.032 35.8485 226.032 42.2953C226.032 42.9791 226.032 43.6629 225.836 44.4444H210.012C210.305 47.6678 212.454 49.426 215.189 49.426C217.534 49.426 218.803 48.2539 219.487 46.7887H225.348C224.273 50.6959 220.659 53.8216 215.385 53.8216ZM210.11 40.6348H220.366C220.269 37.8021 218.022 35.9461 215.189 35.9461C212.552 36.0438 210.501 37.7044 210.11 40.6348Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M245.177 41.514C245.177 37.9975 243.223 36.1416 240.391 36.1416C237.46 36.1416 235.507 37.9975 235.507 41.514V53.4309H230.037V31.746H235.507V34.4809C236.874 32.625 239.218 31.4529 242.051 31.4529C247.131 31.4529 250.647 34.774 250.647 40.7325V53.4309H245.177V41.514Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M256.703 36.337H254.163V31.8437H256.703V26.4713H262.173V31.8437H267.057V36.337H262.173V46.7888C262.173 48.254 262.759 48.8401 264.518 48.8401H267.057V53.431H263.638C259.536 53.431 256.703 51.6727 256.703 46.691V36.337Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M279.267 53.8216C273.797 53.8216 270.085 50.6959 269.792 46.5933H275.262C275.458 48.2539 277.021 49.5237 279.17 49.5237C281.319 49.5237 282.491 48.547 282.491 47.2771C282.491 43.3699 270.281 45.9095 270.281 37.8997C270.281 34.2856 273.504 31.4529 278.877 31.4529C284.151 31.4529 287.277 34.2857 287.57 38.5836H282.295C282.1 36.923 280.83 35.7508 278.681 35.7508C276.63 35.7508 275.555 36.5322 275.555 37.8021C275.555 41.7093 287.57 39.2673 287.668 47.1793C287.765 51.0865 284.542 53.8216 279.267 53.8216Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M209.035 63.8828C209.035 64.7619 208.352 65.348 207.57 65.348C206.691 65.348 206.105 64.6642 206.105 63.8828C206.105 63.1014 206.789 62.4176 207.57 62.4176C208.449 62.4176 209.035 63.1014 209.035 63.8828ZM206.3 63.8828C206.3 64.6642 206.789 65.2502 207.57 65.2502C208.254 65.2502 208.84 64.6642 208.84 63.9805C208.84 63.199 208.352 62.6129 207.57 62.6129C206.886 62.6129 206.3 63.199 206.3 63.8828ZM207.375 64.6642H207.082V63.199C207.179 63.199 207.375 63.199 207.668 63.199C207.961 63.199 208.059 63.1989 208.156 63.2966C208.254 63.3943 208.254 63.492 208.254 63.5897C208.254 63.7851 208.156 63.8828 207.961 63.9805C208.059 64.0781 208.156 64.1758 208.254 64.3712C208.254 64.5666 208.352 64.6641 208.352 64.7618H207.961C207.961 64.6641 207.863 64.5666 207.863 64.3712C207.863 64.1758 207.766 64.1758 207.57 64.1758H207.375V64.6642ZM207.375 63.785H207.57C207.766 63.785 207.863 63.6874 207.863 63.5897C207.863 63.492 207.766 63.3944 207.57 63.3944C207.473 63.3944 207.375 63.3944 207.375 63.3944V63.785Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M122.589 62.8082C122.198 62.8082 121.807 63.1013 121.612 63.4921L119.658 69.5482L117.9 63.4921C117.802 63.1013 117.411 62.8082 117.021 62.8082C116.63 62.8082 116.239 63.1013 116.142 63.4921L114.383 69.5482L112.43 63.4921C112.332 63.1013 111.941 62.8082 111.453 62.8082C110.867 62.8082 110.476 63.2966 110.476 63.785C110.476 64.2734 113.114 72.1856 113.407 73.1624C113.504 73.5531 113.895 73.8461 114.383 73.8461C114.774 73.8461 115.263 73.5531 115.36 73.1624L117.021 67.2038L118.681 73.1624C118.779 73.5531 119.17 73.8461 119.658 73.8461C120.147 73.8461 120.44 73.5531 120.635 73.1624C120.928 72.1856 123.565 64.2734 123.565 63.785C123.565 63.2966 123.175 62.8082 122.589 62.8082Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M155.702 67.0085L158.242 64.4689C158.437 64.2735 158.535 64.0781 158.535 63.785C158.535 63.1989 158.046 62.8082 157.558 62.8082C157.265 62.8082 157.07 62.906 156.874 63.1013L152.186 67.6922V63.8828C152.186 63.2967 151.697 62.8082 151.111 62.8082C150.525 62.8082 150.037 63.2967 150.037 63.8828V72.7717C150.037 73.3577 150.525 73.8461 151.111 73.8461C151.697 73.8461 152.186 73.3577 152.186 72.7717V70.525C152.869 69.8412 153.553 69.1575 154.237 68.4737L157.265 73.3577C157.46 73.6508 157.753 73.8461 158.144 73.8461C158.73 73.8461 159.121 73.3577 159.121 72.8693C159.121 72.674 159.121 72.4786 159.023 72.3809L155.702 67.0085Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M173.382 62.8082C172.992 62.8082 172.601 63.1013 172.405 63.4921L170.452 69.5482L168.694 63.4921C168.596 63.1013 168.205 62.8082 167.814 62.8082C167.424 62.8082 167.033 63.1013 166.935 63.4921L165.177 69.5482L163.223 63.4921C163.126 63.1013 162.735 62.8082 162.247 62.8082C161.661 62.8082 161.27 63.2966 161.27 63.785C161.27 64.2734 163.907 72.1856 164.2 73.1624C164.298 73.5531 164.689 73.8461 165.177 73.8461C165.568 73.8461 166.056 73.5531 166.154 73.1624L167.814 67.2038L169.475 73.1624C169.573 73.5531 169.963 73.8461 170.452 73.8461C170.843 73.8461 171.233 73.5531 171.429 73.1624C171.722 72.1856 174.359 64.2734 174.359 63.785C174.359 63.2966 173.871 62.8082 173.382 62.8082Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M193.895 62.8082C193.504 62.8082 193.114 63.0037 193.016 63.3944L189.988 70.6226L186.96 63.3944C186.862 63.0037 186.471 62.8082 186.081 62.8082C185.592 62.8082 185.104 63.2966 185.104 63.785C185.104 63.8827 185.104 64.0781 185.202 64.1758L189.109 73.2601C189.304 73.6508 189.597 73.8461 189.988 73.8461C190.379 73.8461 190.769 73.6508 190.867 73.2601L194.774 64.1758C194.872 64.0781 194.872 63.8827 194.872 63.785C194.872 63.2966 194.383 62.8082 193.895 62.8082Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M204.542 71.6972H199.463V69.2552H202.1C202.686 69.2552 203.077 68.8645 203.077 68.2784C203.077 67.6923 202.589 67.3016 202.1 67.3016H199.463V64.9573H204.249C204.835 64.9573 205.226 64.4689 205.226 63.9805C205.226 63.3944 204.738 63.0037 204.249 63.0037H198.388C197.802 63.0037 197.314 63.492 197.314 64.0781V72.674C197.314 73.2601 197.802 73.7485 198.388 73.7485H204.542C205.128 73.7485 205.519 73.3577 205.519 72.7717C205.519 72.1856 205.128 71.6972 204.542 71.6972Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M130.598 62.8082C127.473 62.8082 125.031 65.2503 125.031 68.3761C125.031 71.5018 127.473 73.9438 130.598 73.9438C133.724 73.9438 136.166 71.4041 136.166 68.3761C136.068 65.2503 133.724 62.8082 130.598 62.8082ZM130.598 71.9902C128.547 71.9902 127.18 70.3297 127.18 68.3761C127.18 66.4225 128.547 64.7618 130.598 64.7618C132.65 64.7618 133.92 66.3248 133.92 68.3761C133.92 70.3297 132.552 71.9902 130.598 71.9902Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M147.497 66.227C147.497 63.8827 145.739 63.0037 143.59 63.0037H139.585C138.999 63.0037 138.51 63.492 138.51 64.0781V72.8693C138.51 73.4554 138.999 73.9438 139.585 73.9438C140.171 73.9438 140.659 73.4554 140.659 72.8693V69.4505H143.59C143.59 69.5482 145.348 73.0647 145.543 73.3577C145.739 73.7484 146.032 73.9438 146.423 73.9438C147.009 73.9438 147.497 73.4554 147.497 72.8693C147.497 72.3809 146.032 69.6459 145.739 69.0598C146.911 68.5714 147.497 67.4969 147.497 66.227ZM143.883 67.5946H140.659V64.9573H143.883C144.664 64.9573 145.348 65.4456 145.348 66.227C145.348 67.1062 144.664 67.5946 143.883 67.5946Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M174.75 72.4786C174.75 72.5763 174.652 72.7716 174.652 72.8693C174.652 73.4554 175.043 73.8461 175.629 73.8461C175.824 73.8461 176.117 73.7484 176.215 73.553C176.313 73.4554 176.41 73.3577 176.508 73.2601C176.606 73.1624 177.876 70.4273 181.587 70.0366L183.053 73.2601C183.248 73.6508 183.541 73.8461 183.932 73.8461C184.518 73.8461 184.909 73.3577 184.909 72.8693C184.909 72.7716 184.909 72.5763 184.811 72.4786L180.708 63.3944C180.611 63.1014 180.22 62.8082 179.829 62.8082C179.438 62.8082 179.048 63.0037 178.852 63.3944L174.75 72.4786ZM180.806 68.4737C179.829 68.6691 179.048 68.9622 178.364 69.2552L179.829 66.1294L180.806 68.4737Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M93.8706 66.0317C94.359 65.8364 94.8474 65.641 95.4334 65.641C96.1172 65.641 96.801 65.8363 97.2894 66.1294C97.8754 66.4224 98.2662 66.9108 98.6569 67.5946C98.9499 68.1807 99.1453 68.8645 99.1453 69.7436C99.1453 70.5251 98.9499 71.2088 98.6569 71.8925C98.3639 72.4786 97.8754 72.967 97.2894 73.3577C96.7033 73.7484 96.1172 73.8461 95.4334 73.8461C94.8474 73.8461 94.2613 73.7484 93.7729 73.4554C93.2845 73.26 92.8938 72.8693 92.6984 72.5762V73.7485H91.0378V63.199H92.6984V67.1062C92.9915 66.6178 93.3822 66.3248 93.8706 66.0317ZM97.094 68.2784C96.8987 67.8877 96.6056 67.5946 96.2149 67.3993C95.8242 67.2039 95.4335 67.1062 95.0427 67.1062C94.652 67.1062 94.2613 67.2039 93.8706 67.3993C93.4798 67.5946 93.1868 67.8877 92.9914 68.2784C92.7961 68.6691 92.6984 69.1574 92.6984 69.6458C92.6984 70.1342 92.7961 70.6226 92.9914 71.111C93.1868 71.5018 93.4798 71.7948 93.8706 71.9902C94.2613 72.1855 94.652 72.2833 95.0427 72.2833C95.4335 72.2833 95.8242 72.1855 96.2149 71.9902C96.6056 71.7948 96.8987 71.5018 97.094 71.0134C97.2894 70.6227 97.387 70.1343 97.387 69.5482C97.4847 69.1575 97.3871 68.6691 97.094 68.2784Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M107.839 65.8364L103.053 77.3626H101.392L102.955 73.5531L99.829 65.8364H101.685L103.932 71.7949L106.276 65.8364H107.839Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M42.1001 35.0671L42.2955 34.6764L42.1001 35.0671Z", fill: "white" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M39.9512 0C17.8755 0 0 17.9731 0 40.0488C0 62.1245 17.9731 80 40.0488 80C62.1245 80 80 62.0269 80 39.9512C80 17.8755 62.0269 0 39.9512 0ZM4.10256 36.3369C4.3956 34.7741 5.95849 33.7973 7.42369 34.0904C8.88889 34.3834 9.96338 35.9462 9.67034 37.4114C9.3773 38.9743 7.81441 39.9511 6.3492 39.6581C4.78632 39.365 3.80952 37.8998 4.10256 36.3369ZM6.25153 45.812L5.95849 44.8352C5.86081 44.6398 5.8608 44.5421 5.8608 44.3468C5.47008 42.5885 6.64225 40.7326 8.40049 40.4396C10.1587 40.0489 12.0147 41.221 12.3077 42.9792L12.6007 43.956C12.6984 44.1514 12.6984 44.2491 12.6984 44.4444C13.0891 46.2027 11.917 48.0586 10.1587 48.3516C8.40049 48.7424 6.64225 47.6679 6.25153 45.812ZM17.1917 53.138L16.3126 55.1892C15.5311 56.8498 13.5775 57.5335 11.917 56.7521C10.2564 55.9707 9.57265 54.1147 10.2564 52.4541L11.3309 50.1098C12.1123 48.4492 14.0659 47.6679 15.7265 48.4493C17.2894 49.133 17.8755 51.4774 17.1917 53.138ZM54.4078 62.4176C54.4078 62.4176 53.431 64.5665 51.0867 64.4688C49.7192 64.4688 48.547 63.6874 48.0586 62.4176L40.3419 39.1697L32.3321 58.2173C31.9414 59.0964 31.16 59.7802 30.1831 60.0732C28.3272 60.6593 26.3736 59.5848 25.8852 57.7289L21.1966 43.4676L20.4151 45.3236C20.3175 45.6166 20.1221 45.9096 19.8291 46.2026C18.8523 47.2771 17.2894 47.6678 15.9219 47.0817C14.2613 46.3003 13.4799 44.3467 14.2613 42.6861L14.359 42.3932L18.2662 32.039C19.0476 30.2808 21.0989 29.4994 22.8571 30.2808C23.6386 30.6715 24.3223 31.3553 24.6154 32.1368V32.2344L26.3736 37.4114L26.6667 38.3882C26.6667 38.3882 26.6667 38.3883 26.6667 38.486V38.5836L29.4017 46.4957L37.3138 27.6434C38.0952 25.8851 40.1465 25.1038 41.9048 25.8852C42.8816 26.3736 43.5653 27.1551 43.8584 28.2296L45.7143 33.8949L45.812 34.3833C45.812 34.3833 45.812 34.3833 45.812 34.481L45.7143 34.188V34.2857C45.9096 34.8718 51.1844 50.9889 51.1844 50.9889L63.5897 21.4896C63.5897 21.4896 65.348 18.4615 68.083 19.829C70.9157 21.1965 69.9389 24.0293 69.9389 24.0293L54.4078 62.4176Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29.597 46.4956L26.862 38.5836V38.4859C26.569 37.7045 25.7875 36.8253 24.6154 37.1184C23.7362 37.4114 23.2478 38.2905 23.0525 38.7789L21.0989 43.4676L25.7875 57.8265C26.3736 59.6824 28.3272 60.6593 30.0854 60.1709C31.0622 59.8778 31.8437 59.194 32.2344 58.3149L32.9182 56.6544L29.597 46.4956Z",
            fill: "url(#paint0_linear_30_24)",
            opacity: "0.7"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M51.5751 50.8913L50.696 48.0586L46.2027 34.3834C45.9097 33.5043 45.1282 32.6251 43.956 33.0158C43.0769 33.3089 42.5885 34.1881 42.3932 34.6765L40.4396 39.2674L48.0586 62.5153C48.547 63.7851 49.7192 64.5665 51.0867 64.5665C53.431 64.6642 54.4078 62.5153 54.4078 62.5153L54.8962 61.2454L51.5751 50.8913Z",
            fill: "url(#paint1_linear_30_24)",
            opacity: "0.7"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              gradientUnits: "userSpaceOnUse",
              id: "paint0_linear_30_24",
              x1: "23.1078",
              x2: "18.8921",
              y1: "46.593",
              y2: "44.2555",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#4D4A4A", stopOpacity: "0" }),
                /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#221F1F" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              gradientUnits: "userSpaceOnUse",
              id: "paint1_linear_30_24",
              x1: "41.0067",
              x2: "34.0828",
              y1: "45.0834",
              y2: "41.2426",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#221F1F", stopOpacity: "0" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.02", stopColor: "#221F1F", stopOpacity: "0.04" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.19", stopColor: "#221F1F", stopOpacity: "0.31" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.36", stopColor: "#221F1F", stopOpacity: "0.53" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.53", stopColor: "#221F1F", stopOpacity: "0.71" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.69", stopColor: "#221F1F", stopOpacity: "0.83" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.85", stopColor: "#221F1F", stopOpacity: "0.9" }),
                /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#221F1F", stopOpacity: "0.93" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
validateTidalLicense();
export {
  WorkWavePaymentsInverted
};
//# sourceMappingURL=WorkWavePaymentsInverted.js.map
